module.exports = __webpack_public_path__ + "static/media/powerPoint.634ca915.svg";